/*
 * Textarea + Emoji Picker Support (Conditional via props.emoji)
 */

import { useState, useEffect, useRef } from "react";
import emojiData from "emoji.json";
import styles from '../../styles/components/textarea.module.scss';

const TextArea = (props) => {

	const [value, setValue] = useState("");
	const [error, setError] = useState(null);
	const [showEmojiPicker, setShowEmojiPicker] = useState(false);
	const textRef = useRef(null);

	useEffect(() => {
		if (props.defaultValue) {
			setValue(props.defaultValue);
		}
	}, [props.defaultValue]);

	const valueChange = (e) => {
		setValue(e.target.value);
		setError(null);
		props.valueChange(e.target.value || "");
		autoResize();
	};

	const validate = () => {
		if (props.mandatory && value.trim() === "") {
			setError({ error: "Shouldn't allow only white space" });
			props.fail(false);
		}
	};

	/* Insert emoji at caret position */
	const insertEmoji = (emoji) => {
		const textarea = textRef.current;
		if (!textarea) return;

		const start = textarea.selectionStart;
		const end = textarea.selectionEnd;

		const updated =
			value.substring(0, start) + emoji + value.substring(end);

		setValue(updated);
		props.valueChange(updated);

		setTimeout(() => {
			textarea.focus();
			textarea.selectionStart = textarea.selectionEnd = start + emoji.length;
		}, 0);

		setShowEmojiPicker(false);
	};

	const keyPress = (e) => {
		if (e.which === 32 && e.target.selectionStart < 1) {
			e.preventDefault();
		}
		if (e.key === "Enter") {
			setTimeout(() => autoResize(), 0);
		}
	};


	const autoResize = () => {
		const textarea = textRef.current;
		if (textarea) {
			textarea.style.height = "auto";   // Reset
			textarea.style.height = textarea.scrollHeight + "px"; // Expand
		}
	};
	return (
		<div className={`${styles.e_textarea_wrap} position-relative`}>

			{/* Textarea */}
			<textarea
				data-resize={props.resize ? props.resize : false}
				ref={textRef}
				id={props.id}
				value={props.value ?? value}
				type={props.type}
				className={
					error
						? `${styles.e_input_error} ${styles.e_textarea} ${props.className}`
						: `${styles.e_textarea} ${props.className}`
				}
				onChange={(e) => valueChange(e)}
				placeholder={props.placeholder}
				required={props.required}
				rows={props.rows}
				cols={props.cols}
				onBlur={validate}
				onKeyDown={keyPress}
			/>

			{/* Emoji Button — only if props.emoji === true */}
			{props.emoji && (
				<button
					type="button"
					className="e-emoji-btn"
					onClick={() => setShowEmojiPicker(!showEmojiPicker)}
				>
					<span>😀</span>
				</button>
			)}

			{/* Emoji Picker — only if props.emoji === true */}
			{props.emoji && showEmojiPicker && (
				<>
					<div className="e-emoji-bd" onClick={() => setShowEmojiPicker(false)}></div>
					<div className="e-emoji-picker"
					>
						{emojiData.slice(0, 1500).map((emoji) => (
							<span
								key={emoji.codes}
								onClick={() => insertEmoji(emoji.char)}
								className="e-emoji"
							>
								{emoji.char}
							</span>
						))}
					</div>
				</>
			)}

			{props.label && (
				<label htmlFor={props.id} className="label">
					{props.label}
				</label>
			)}

			{error && <p className={styles.e_error_msg + " mb-0"}>{error}</p>}
		</div>
	);
};

export default TextArea;
